<template>
  <b-tab>
    <template #title>
      <i class="mdi mdi-draw"></i> Assinatura Digital
    </template>
    <form-file
      @submit="submitFile"
      btn-text="Iniciar"
      :progress="progressCompleted"
      label="Upload da assinatura digital"
      accept="image/png,image/jpeg,image/jpg"
      class="px-0"
    />
    <h4 class="d-block font-weight-bold">
      Ou use o campo abaixo para desenhar sua assinatura
    </h4>
    <div class="col-12">
      <canvas
        id="myCanvas"
        width="900"
        height="150"
        @mousedown="beginDrawing"
        @mousemove="keepDrawing"
        @mouseup="stopDrawing"
        @touchstart.prevent="beginTouch"
        @touchmove.prevent="moveTouch"
        @touchend.prevent="stopTouch"
      />
    </div>
    <div class="float-right mt-3">
      <button
        class="btn btn-success btn-submit"
        data-style="zoom-in"
        @click="saveAssinatura"
      >
        <i class="mdi mdi-content-save" />
        {{ $t("Salvar") }}
      </button>
    </div>
    <load v-if="sending" mode="table" message="Salvando assinatura" />
    <div class="col-12 mt-5" v-if="assinatura_digital && !sending">
      <h4>Assinatura digital do técnico</h4>
      <img :src="assinatura_digital" class="mx-auto" style="width: 500px" />
    </div>
  </b-tab>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    status: {
      type: Object,
      default: () => {},
    },
    passwordInput: {
      type: String,
      default: null,
    },
    showAssinatura: {
      type: Boolean,
      default: false,
    },
    historicoStatus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      progressCompleted: 0,
      files: [],
      x: 0,
      y: 0,
      isDrawing: false,
      sending: false,
      canvas: null,
      assinatura_digital: null,
    };
  },
  mounted() {
    var c = document.getElementById("myCanvas");
    this.canvas = c.getContext("2d");
    this.assinatura_digital = this.item.assinatura_digital;

    // Evitar o scroll do canvas no mobile
    const canvas = document.getElementById("myCanvas");
    canvas.addEventListener(
      "touchstart",
      (e) => {
        e.preventDefault();
      },
      { passive: false }
    );
    canvas.addEventListener(
      "touchmove",
      (e) => {
        e.preventDefault();
      },
      { passive: false }
    );

  },
  methods: {
    beginTouch(e) {
      const touch = e.touches[0];
      const rect = e.target.getBoundingClientRect();

      this.x = touch.clientX - rect.left;
      this.y = touch.clientY - rect.top;

      this.isDrawing = true;
    },

    moveTouch(e) {
      if (!this.isDrawing) return;

      const touch = e.touches[0];
      const rect = e.target.getBoundingClientRect();

      const newX = touch.clientX - rect.left;
      const newY = touch.clientY - rect.top;

      this.drawLine(this.x, this.y, newX, newY);

      this.x = newX;
      this.y = newY;
    },

    stopTouch() {
      this.isDrawing = false;
      this.x = 0;
      this.y = 0;
    },

    saveAssinatura() {
      this.sending = true;
      const canvas = document.getElementById("myCanvas");
      const files = canvas.toDataURL();
      this.submitFile(this.dataURLtoFile(files, "assinatura.png"));
    },
    submitFile(files) {
      this.files = files;
      let formData = new FormData();
      this.sending = true;
      formData.append("assinatura", this.files);
      formData.append("id", this.item.id);
      axios
        .post(`api/dashboard/tecnico/upload/assinatura`, formData, {
          header: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (event) => {
            let progress = Math.round((event.loaded * 100) / event.total);
            this.progressCompleted = progress;
          },
        })
        .then((response) => {
          this.assinatura_digital = response.data;
          this.progressCompleted = 0;
          this.sending = false;
        });
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[arr.length - 1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    drawLine(x1, y1, x2, y2) {
      let ctx = this.canvas;
      ctx.beginPath();
      ctx.strokeStyle = "black";
      ctx.lineWidth = 1;
      ctx.moveTo(x1, y1);
      ctx.lineTo(x2, y2);
      ctx.stroke();
      ctx.closePath();
    },
    beginDrawing(e) {
      this.x = e.offsetX;
      this.y = e.offsetY;
      this.isDrawing = true;
    },
    keepDrawing(e) {
      if (this.isDrawing === true) {
        this.drawLine(this.x, this.y, e.offsetX, e.offsetY);
        this.x = e.offsetX;
        this.y = e.offsetY;
      }
    },
    stopDrawing(e) {
      if (this.isDrawing === true) {
        this.drawLine(this.x, this.y, e.offsetX, e.offsetY);
        this.x = 0;
        this.y = 0;
        this.isDrawing = false;
      }
    },
  },
};
</script>
<style>
#myCanvas {
  border: 1px solid grey;
}
</style>
